export const extractSize = (
  attributesArray: Record<string, string>,
): string => {
  const sizeKeys = [
    "Rozmiar",
    "Rozmiar spodni",
    "Rozmiar dziecięcy",
    "Rozmiar butów",
    "Rozmiar kapelusza",
    "Rozmiar szortów",
    "Rozmiar skarpet",
  ];

  for (const key of sizeKeys) {
    if (attributesArray[key]) {
      return attributesArray[key];
    }
  }

  return "";
};
